import { useContentSelector } from '@wajeez-web/stores/content';

export const useContentEntityListsLookups = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.lookups
  );
};

export const useContentEntityListsDatatable = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.datatable
  );
};

export const useContentEntityListsByContentEntityId = () => {
  return useContentSelector(
    ({ contentEntityLists }) =>
      contentEntityLists.contentEntityListsByContentEntityId
  );
};

export const useContentEntityListItems = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.contentEntityListItems
  );
};

export const useSetContentEntityListsItemList = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.setContentEntityListsItemList
  );
};

export const useCreateContentEntityList = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.create
  );
};

export const useEditContentEntityList = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.edit
  );
};

export const useContentEntityListById = () => {
  return useContentSelector(
    ({ contentEntityLists }) => contentEntityLists.byId
  );
};
